import en from './en.json'
import it from './it.json'

export const auditTranslations = {
	en,
	it
} as const
